import { followConfigFormModel } from './followConfigFormModel';
const {
  formField: { scoreThreshold },
} = followConfigFormModel;

export default {
  [scoreThreshold.name]: '',
};
